import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CSSProperties } from "react";
import { rectangleStyle } from "../../utils/Tesseract";

export const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  document: {
    height: "200px",
  },
  formControl: {
    position: "absolute",
    right: 0,
    top: 0,
    margin: "10px",
  },
  root: {
    backgroundColor: "#F6F8FD",
    padding: 15,
  },
  box: {
    position: "relative",
  },
  video: {
    width: "100%",
    height: "100%",
  },
  rectangle: {
    "&:before": {
      content: `''`,
      position: "absolute",
      padding: "5px",
      borderRadius: "5px",
      top: "-3px",
      left: "-3px",
      bottom: "-3px",
      right: "-3px",
      border: `5px solid ${theme.palette.primary.main}`,
      filter: "blur(1px)",
    },
  },
  detectMrz: {
    "&:before": {
      content: `''`,
      position: "absolute",
      padding: "5px",
      borderRadius: "5px",
      top: "-3px",
      left: "-3px",
      bottom: "-3px",
      right: "-3px",
      border: `6px solid ${theme.palette.primary.light}`,
      filter: "blur(2px)",
    },
  },
  buttonEnable: {
    position: "absolute",
    margin: 10,
    top: 0,
    right: 0,
  },
  buttonDisable: {
    position: "absolute",
    margin: 10,
    top: 0,
    right: 0,
  },
  detectingBox: {
    position: "absolute",
    zIndex: 99,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "#fff",
    filter: "blur(30px)",
    opacity: "0.5",
  },
  circularProgress: {
    position: "absolute",
    zIndex: 999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
}));

export const styleDetectMrz = (
  theme: Theme,
  width: number,
  height: number
): CSSProperties => {
  const top = width > height ? 30 : 40;
  const heightCenter = width > height ? 30 : 20;
  return {
    position: "absolute",
    border: `2px solid ${theme.palette.primary.main}`,
    left: rectangleStyle.left,
    top: top + rectangleStyle.unit,
    height: heightCenter + rectangleStyle.unit,
    width: rectangleStyle.width + rectangleStyle.unit,
    borderRadius: "5px",
    filter: "blur(2px)",
  };
};

export const styleRectangleMrz = (
  theme: Theme,
  width: number,
  height: number
): CSSProperties => {
  const top = width > height ? 30 : 40;
  const heightCenter = width > height ? 30 : 20;
  return {
    position: "absolute",
    border: `2px solid ${theme.palette.primary.main}`,
    left: rectangleStyle.left,
    top: top + rectangleStyle.unit,
    height: heightCenter + rectangleStyle.unit,
    width: rectangleStyle.width + rectangleStyle.unit,
    borderRadius: "5px",
  };
};
